import { styled } from 'styled-components';

import { media } from '../../utils/mediaQueries';

export const MoveIcon = styled.div`
  position: absolute;
  top: 15px;
  left: 15px;
  opacity: 0;
  pointer-events: none;
  transition: all 0.3s ease-in-out;
  z-index: 55;
  width: 30px;
  height: 30px;
  background: ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#fff')};
  color: ${({ theme }) => (theme.mode === 'dark' ? '#d1d5db' : '#000')};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  box-shadow: ${({ theme }) => (theme.mode === 'dark' ? 'rgba(0, 0, 0, 0.3) 0 2px 6px' : 'rgba(37, 83, 185, 0.1) 0 2px 6px')} !important;

  ${media.tabletDown} {
    display: none;
  }
`;

// Badge z numerem pozycji dla desktop - mały i dyskretny
export const PositionBadge = styled.div`
  display: none;
  position: absolute;
  top: 8px;
  left: 8px;
  min-width: 24px;
  height: 24px;
  padding: 0 6px;
  background: ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#f1f5f9')};
  color: ${({ theme }) => (theme.mode === 'dark' ? '#1a4d4d' : '#1a4d4d')};
  font-size: 11px;
  font-weight: 400;
  border-radius: 6px;
  z-index: 60;
  align-items: center;
  justify-content: center;
  border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#4b5563' : '#e2e8f0')};

  ${media.desktop} {
    display: flex;
  }
`;

// Drag handle widoczny na desktop - mniejszy, w rogu karty
export const DesktopDragHandle = styled.div`
  display: none;
  position: absolute;
  top: 8px;
  right: 8px;
  width: 28px;
  height: 28px;
  background: ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#ffffff')};
  border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#4b5563' : '#e5e7eb')};
  border-radius: 6px;
  cursor: grab;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#9ca3af' : '#9ca3af')};
  transition: all 0.2s ease;

  &:hover {
    background: ${({ theme }) => (theme.mode === 'dark' ? '#4b5563' : '#f3f4f6')};
    color: #1a4d4d;
  }

  &:active {
    cursor: grabbing;
    transform: scale(0.95);
  }

  ${media.desktop} {
    display: flex;
  }
`;

export const DraggedCardContainer = styled.div<{ $isHovered: boolean; $isDragging: boolean }>`
  display: flex;
  flex-direction: column;
  overflow: visible;
  position: relative;
  cursor: ${({ $isDragging }) => ($isDragging ? 'grab' : 'default')};
  transition: all 0.2s ease;

  background-color: ${({ $isHovered, theme }) => {
    if ($isHovered) return theme.mode === 'dark' ? 'rgba(224, 123, 45, 0.15)' : 'rgba(224, 123, 45, 0.08)';
    return 'transparent';
  }};
  opacity: ${({ $isHovered }) => ($isHovered ? 0.7 : 1)};
  padding: ${({ $isHovered }) => ($isHovered ? '4px' : '0px')};
`;

export const DraggedRow = styled.tr<{ $isHovered: boolean; $isDragging: boolean }>`
  position: relative;
  cursor: ${({ $isDragging }) => ($isDragging ? 'grab' : 'default')};
  background-color: ${({ $isHovered, theme }) => {
    if ($isHovered) return theme.mode === 'dark' ? 'rgba(224, 123, 45, 0.15)' : 'rgba(224, 123, 45, 0.08)';
    return 'transparent';
  }};
  border-bottom: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#f3f4f6')};
  transition: all 0.2s ease;

  &:hover {
    background: ${({ theme }) => (theme.mode === 'dark' ? '#242a33' : '#f9fafb')};
  }

  &:last-child {
    border-bottom: none;
  }

  ${media.mobile} {
    display: block;
    background: ${({ theme }) => (theme.mode === 'dark' ? '#1a1f26' : '#ffffff')};
    border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#e5e7eb')};
    border-radius: 6px;
    padding: 12px;

    &:hover {
      background: ${({ theme }) => (theme.mode === 'dark' ? '#1a1f26' : '#ffffff')};
    }

    &:active {
      background: ${({ theme }) => (theme.mode === 'dark' ? '#1a1f26' : '#ffffff')};
    }

    &:last-child {
      border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#e5e7eb')};
    }
  }
`;

export const DragHandle = styled.div`
  font-size: 14px;
  cursor: grab;
  transition: background-color 0.2s ease;

  &:active {
    cursor: grabbing;
  }

  ${media.tabletDown} {
    cursor: default;
    pointer-events: none;
  }
`;

export const MobileReorderButtons = styled.div`
  display: none;
  position: absolute;
  top: 50%;
  right: 8px;
  transform: translateY(-50%);
  flex-direction: row;
  gap: 4px;
  z-index: 100;
  pointer-events: auto;

  ${media.tabletDown} {
    display: flex;
  }
`;

// Komórka z indeksem pozycji dla desktop
export const TablePositionCell = styled.td`
  display: none;
  position: relative;
  width: 50px;
  min-width: 50px;
  padding: 8px !important;
  vertical-align: middle;
  text-align: center;

  ${media.desktop} {
    display: table-cell;
  }
`;

export const TablePositionHeader = styled.th`
  display: none;
  width: 50px;
  min-width: 50px;
  padding: 8px !important;
  text-align: left;
  font-size: 11px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.text.muted};
  background: ${({ theme }) => theme.colors.background.tertiary};

  ${media.desktop} {
    display: table-cell;
  }
`;

export const PositionNumber = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  margin: 0 auto;
  background: ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#f1f5f9')};
  color: #1a4d4d;
  font-size: 12px;
  font-weight: 400;
  border-radius: 6px;
  border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#4b5563' : '#e2e8f0')};
`;

export const TableReorderCell = styled.td`
  display: table-cell;
  position: relative;
  width: 80px;
  min-width: 80px;
  padding: 8px !important;
  vertical-align: middle;

  ${media.mobile} {
    display: block;
    position: absolute;
    top: 12px;
    right: 12px;
    width: auto;
    min-width: auto;
    padding: 0 !important;
    background: transparent;
  }
`;

export const TableReorderHeader = styled.th`
  background: ${({ theme }) => theme.colors.background.tertiary};
  display: none;
  width: 80px;
  min-width: 80px;
  padding: 8px !important;

  ${media.tablet} {
    display: table-cell;
  }

  ${media.mobile} {
    display: none;
  }
`;

export const TableReorderButtons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  justify-content: center;
  align-items: center;
`;

export const ReorderButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 6px;
  border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#4b5563' : '#e5e7eb')};
  background: ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#ffffff')};
  color: ${({ theme }) => (theme.mode === 'dark' ? '#d1d5db' : '#374151')};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  transition: all 0.2s ease;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  user-select: none;

  &:hover:not(:disabled) {
    background: ${({ theme }) => (theme.mode === 'dark' ? '#4b5563' : '#f3f4f6')};
  }

  &:active:not(:disabled) {
    transform: scale(0.95);
    background: ${({ theme }) => (theme.mode === 'dark' ? '#4b5563' : '#e5e7eb')};
  }

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
`;
